import React from "react";
import {
    Chart,
    ChartArea,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartXAxis,
    ChartYAxis,
    ChartXAxisItem,
    ChartYAxisItem,
    ChartTooltip,
} from "@progress/kendo-react-charts";

interface DepletionCurveGraphData {
    wiggins: any[];
    depletion10Percent: any[];
    depletion20Percent: any[];
    depletion30Percent: any[];
    depletion40Percent: any[];
    depletion50Percent: any[];
    depletion60Percent: any[];
    depletion70Percent: any[];
    generalDepletion: any[];
    
}

interface DepletionCurveGraphProps {
    data: DepletionCurveGraphData;
}

const DepletionCurveGraph: React.FC<DepletionCurveGraphProps> = ({ data }) => {
    if (!data) return <div>No data available</div>;

    return (
        <Chart>
            <ChartArea background="transparent" />

            {/* Legend */}
            <ChartLegend position="bottom" labels={{ font: "16px Mulish", color: "#fff" }} />

            {/* Series */}
            <ChartSeries>
                <ChartSeriesItem
                    name="Wiggins (Liquid)"
                    type="scatterLine"
                    data={data.wiggins}
                    xField="liquidRate"
                    yField="fbhp"
                    color="orange"
                    style="smooth"
                    markers={{ visible: true }}
                    width={4.0}
                    tooltip={{ visible: true, format: "{0} x {1}" }}
                />
                <ChartSeriesItem
                    name="10% Depletion"
                    type="scatterLine"
                    data={data.depletion10Percent}
                    xField="liquidRate"
                    yField="fbhp"
                    color="#2098ae"
                    style="smooth"
                    markers={{ visible: true }}
                    width={4.0}
                    tooltip={{ visible: true, format: "{0} x {1}" }}
                />
                <ChartSeriesItem
                    name="20%"
                    type="scatterLine"
                    data={data.depletion20Percent}
                    xField="liquidRate"
                    yField="fbhp"
                    color="gray"
                    style="smooth"
                    markers={{ visible: true }}
                    width={4.0}
                    tooltip={{ visible: true, format: "{0} x {1}" }}
                />
                <ChartSeriesItem
                    name="30%"
                    type="scatterLine"
                    data={data.depletion30Percent}
                    xField="liquidRate"
                    yField="fbhp"
                    color="#8a9042"
                    style="smooth"
                    markers={{ visible: true }}
                    width={4.0}
                    tooltip={{ visible: true, format: "{0} x {1}" }}
                />
                <ChartSeriesItem
                    name="40%"
                    type="scatterLine"
                    data={data.depletion40Percent}
                    xField="liquidRate"
                    yField="fbhp"
                    color="#440d31"
                    style="smooth"
                    markers={{ visible: true }}
                    width={4.0}
                    tooltip={{ visible: true, format: "{0} x {1}" }}
                />
                <ChartSeriesItem
                    name="50%"
                    type="scatterLine"
                    data={data.depletion50Percent}
                    xField="liquidRate"
                    yField="fbhp"
                    color="green"
                    style="smooth"
                    markers={{ visible: true }}
                    width={4.0}
                    tooltip={{ visible: true, format: "{0} x {1}" }}
                />
                <ChartSeriesItem
                    name="60%"
                    type="scatterLine"
                    data={data.depletion60Percent}
                    xField="liquidRate"
                    yField="fbhp"
                    color="blue"
                    style="smooth"
                    markers={{ visible: true }}
                    width={4.0}
                    tooltip={{ visible: true, format: "{0} x {1}" }}
                />
                <ChartSeriesItem
                    name="70%"
                    type="scatterLine"
                    data={data.depletion70Percent}
                    xField="liquidRate"
                    yField="fbhp"
                    color="brown"
                    style="smooth"
                    markers={{ visible: true }}
                    width={4.0}
                    tooltip={{ visible: true, format: "{0} x {1}" }}
                />
                <ChartSeriesItem
                    name="General Depletion Curve"
                    type="scatterLine"
                    data={data.generalDepletion}
                    xField="liquidRate"
                    yField="fbhp"
                    color="red"
                    style="smooth"
                    markers={{ visible: true }}
                    width={4.0}
                    tooltip={{ visible: true, format: "{0} x {1}" }}
                />
            </ChartSeries>

            {/* X Axis */}
            <ChartXAxis>
                <ChartXAxisItem
                    title={{ text: `Liquid Rate [STB / D]`, font: "16px Mulish",  color: "#fff",  }}
                    majorGridLines={{ width: 0.8, color: "#A0A0A0",}}
                    minorGridLines={{ width: 0.3, color: "#A0A0A0", visible: false }}
                    color="#fff"
                    crosshair={{ visible: true, width: 1, color: "#005F7C" }}
                />
            </ChartXAxis>

            {/* Y Axis */}
            <ChartYAxis>
                <ChartYAxisItem
                    name="FBHP"
                    title={{ text: `Flowing Bottomhole Pressure [PSI]`,font: "16px Mulish",  color: "#fff", }}
                    min={0}
                    color="#fff"
                    majorGridLines={{ width: 0.8, color: "#A0A0A0", step:2 }}
                    minorGridLines={{ width: 0.3, color: "#A0A0A0", visible: false }}
                    crosshair={{ visible: true, width: 1, color: "#005F7C" }}
                />
            </ChartYAxis>            

            {/* Tooltip */}
            <ChartTooltip visible={true} />
        </Chart>
    );
};

export default React.memo(DepletionCurveGraph);
